// @flow

import React from "react";
import { Sentry } from "@nested/isomorphic-sentry";
import { ErrorPage } from "@nested/brand";

type Props = { children: React$Node };
type State = { hasError: boolean };

// Has to be a class component because hooks don't support componentDidCatch yet
export class ErrorHandler extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error) {
    this.setState({
      hasError: true,
    });

    Sentry.captureException(error);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <ErrorPage />;
    }

    return children;
  }
}
